import classNames from 'classnames';
import React from 'react';

import { CloseButton } from '@app/components/button';
import { useScroll } from '@app/hooks';

export const CardTabOverlay = ({
	className,
	show,
	onClose,
	children,
	setContainerHeight = null,
	tabType = '',
}) => {
	const [isOpen, setIsOpen] = React.useState(show);
	const [overlayRef, scrollToRef] = useScroll();
	const panelRef = React.useRef();

	/**
	 * Handle updates for scrolling and setting container height:
	 *
	 * - Scroll to overlay ref when overlay container is shown.
	 * - Set overlay's parent container height to fit overlay properly
	 */
	React.useEffect(() => {
		setIsOpen(show);
		if (show) {
			scrollToRef();
		}
	}, [setIsOpen, show, scrollToRef]);

	React.useEffect(() => {
		if (isOpen && setContainerHeight) {
			setContainerHeight(panelRef.current.offsetHeight, tabType);
		}
	}, [isOpen, setContainerHeight, tabType, panelRef]);

	/**
	 * Handles close of overlay:
	 *
	 * - Closes overlay
	 * - Reset overlay's parent container height
	 */
	const handleClose = () => {
		if (onClose) {
			onClose();
		}

		if (setContainerHeight && tabType) {
			setContainerHeight('auto', tabType);
		}

		setIsOpen(false);
	};

	return (
		<div
			className={classNames('course-overlay__container', className, {
				'is-slid': isOpen,
			})}
			ref={overlayRef}
		>
			<div className="course-overlay__panel" ref={panelRef}>
				<CloseButton onClick={handleClose} srLabel="Close Card Overlay" />
				{children}
			</div>
		</div>
	);
};
